import { CssBaseline, Toolbar, Box } from '@mui/material';
import React, { useEffect } from 'react';
import ConfigSidebar from '../../components/Navbar/ConfigSidebar';
import NewNavbar from '../../components/Navbar/New/Navbar';
import theme from '../../mui-theme';
import FloatingButton from '../../components/elements/Floating-Button';
import { useNavigate, useParams } from 'react-router-dom';
import { getCurrentUserAssociation } from '../../modules/project';

const ConfigLayout = ({ children, selectedTab, setSelectedTab }) => {
  const navigate = useNavigate();
  const { projectId } = useParams();

  const fetchCurrentUserData = async () => {
    try {
      await getCurrentUserAssociation(projectId);
    } catch (error) {
      navigate('/access-denied');
    }
  };

  useEffect(() => {
    if (projectId) {
      fetchCurrentUserData();
    }
  }, [projectId]);
  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      <CssBaseline />
      <NewNavbar />
      <ConfigSidebar
        theme={theme}
        setSelectedTab={setSelectedTab}
        selectedTab={selectedTab}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          overflow: 'auto',
          padding: '16px',
        }}>
        <Toolbar />
        <Box sx={{ flexGrow: 1, padding: '16px' }}>{children}</Box>
        <FloatingButton />
      </Box>
    </Box>
  );
};

export default ConfigLayout;
